import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import VueSweetalert2 from 'vue-sweetalert2';
import { MonthPicker, MonthPickerInput } from 'vue-month-picker';
// Axios Mock Adapter
import '@/@fake-db/db'
//import vueConfig from 'vue.config'
// BSV Plugin Registration
import SmoothPicker from 'vue-smooth-picker'
import 'vue-smooth-picker/dist/css/style.css'
Vue.use(SmoothPicker)
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueSweetalert2)

Vue.use(MonthPicker)
Vue.use(MonthPickerInput)
import { VBToggle } from 'bootstrap-vue'
Vue.directive('b-toggle', VBToggle)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
Vue.prototype.$apiUrl='https://proxy.dap.rocks/ganapp.dap.rocks/api/'
Vue.prototype.$fileUpUrl='https://upload.imagekit.io/api/v2/files/upload'
Vue.prototype.$filesUrl='http://ganapp.dap.rocks/uploads/'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
